/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import MainHeader from "../../../../Shared/components/Header";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import clsx from "clsx";
import { NavLink } from "react-router-dom";
import { Row, Col, Image, Space } from "antd";
import { Button, Box, TextField } from "@mui/material";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import { useDispatch, useSelector } from "react-redux";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import { customAlaphaNumericOnlyValidation, emptyValidation } from "../../../../../helpers/validation";
import usePrevious from "../../../../Shared/components/Previous";
import { HsnCodeTable } from "./HsnCodeTable";
import crudActions from "../../../../CRUD/redux/actions";
import { toast } from 'react-toastify';
import DeleteModal from "../../../../Shared/components/DeleteModal";
import CustomAlert from "../../../../Shared/components/CustomAlert";
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import actions from "../../redux/actions";
import { checkCRUDPermission, checkComponentPermission } from '../../../../../helpers/utilities';
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";

const HsnCode = (props) => {
    const { productGstdetails, hsnDetails, hsnLoader } = useSelector(state => state.adminSetupReducer);
    const { createDetails, createError, createLoader, editDetails, editError, editLoader, getList, getData } = useSelector(state => state.crudReducer);
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const [visible, setVisible] = useState(false);
    const [errorCode, setErrorCode] = useState(false);
    const [errorDescription, setErrorDescription] = useState(false);
    const [errorChapter, setErrorChapter] = useState(false);
    const [commonError, setCommonError] = useState(false);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);

    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);

    const [addMore, setAddMore] = useState(false);
    const [hsnId, setHsnId] = useState('');
    const [hsnCode, setHsnCode] = useState('');
    const [deleteModal, setDeleteModal] = useState(false);

    const [form, setForm] = useState({ productGst: '' });
    //  const [formPercentage, setFormPercentage] = useState(false);

    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [importVisible, setImportVisible] = useState(false);

    const { roleManagement } = useSelector(state => state.authReducer);
    const { moduleType } = props;

    const changeHandler = (e, name = '') => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const classes = customStyles();

    const handleOpen = () => {
        setVisible(true);
        emptyStateInput();
        emptyState();
    };
    const handleClose = () => {
        setVisible(false);
        emptyStateInput();
        emptyState();
    };

    const createHsnCode = (e) => {
        e.preventDefault();
        let emptyCode = customAlaphaNumericOnlyValidation('HSN Code', form.hsnCode);
        let emptyDescription = emptyValidation('Description', form.description);
        // let numberValidation = customNumberValidationOptional('Chapter', form.chapter);
        // let emptyProductGst = emptyValidation('Product Gst', form.productGstId);
        if (emptyCode.isValid && emptyDescription.isValid) {
            let data = Object.fromEntries(Object.entries(form).filter(([_, v]) => v != null && v !== ''));
            if (data?.productGst) {
                data.productGst = parseFloat(data?.productGst);
            }
            dispatch({
                type: hsnId === '' ? crudActions.CREATE_DETAILS_START : crudActions.EDIT_DETAILS_START,
                url: 'hsns',
                title: 'HSN Code',
                id: hsnId,
                method: 'put',
                details: data
            });
        } else {
            if (emptyCode.errors) {
                setErrorCode(emptyCode.errors);
            } if (emptyDescription.errors) {
                setErrorDescription(emptyDescription.errors);
            }
            //  if (numberValidation.errors) {
            //     setErrorChapter(numberValidation.errors);
            // } 
            // if (emptyProductGst.errors) {
            //     setErrorGstId(emptyProductGst.errors);
            // }
        }
    }

    const loadTasks = useCallback(() => {
        //  dispatch({ type: productActions.PRODUCTGST_DETAILS_START, url: 'productgst' });
        dispatchFilter(sortBy, sortOrder);
    });


    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["or"]: [] };
        if (search !== '') {
            filter['or'].push({ hsnCode: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ description: { like: '%' + search.trim() + '%' } });
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: "hsns",
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            },
        });
    }

    useEffect(() => {
        if (roleManagement !== '') {
            // if (checkViewPermission('HSN Code', history, 'Younote Admin')) {
            loadTasks();
            // }
        }
    }, [roleManagement]);

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData?.length > 0) {
                    setLoadMore(true);
                    if (getData?.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const handleAddMore = (e) => {
        createHsnCode(e);
        setAddMore(true);
    }

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    const onDelete = (data) => {
        setDeleteModal(true);
        setHsnId(data.id);
        setHsnCode(data.hsnCode);
    };


    useEffect(() => {
        if ((prevSearch !== undefined && search && search?.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
                setLoadMore(false);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                    setLoadMore(false);
                }, 500);
            }
        }
    }, [search]);

    const emptyStateInput = () => {
        setForm({ productGst: '' });
        setHsnId('');
    };

    const emptyState = () => {
        setErrorCode(false);
        setErrorDescription(false);
        setErrorChapter(false);
        setCommonError(false);
    };


    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            dispatchFilter(sortBy, sortOrder);
            handleClose();
            toast.dismiss();
            toast(createDetails);
            if (addMore) {
                setAddMore(false);
                setTimeout(function () {
                    setVisible(true);
                }, 500)
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let error = createError.error.message;
            setCommonError(error);
        }
    }, [createDetails, createError]);


    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            dispatchFilter(sortBy, sortOrder);
            handleClose();
            toast.dismiss();
            toast(editDetails);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let error = editError.error.message;
            setCommonError(error);
        }
    }, [editDetails, editError]);


    const onEdit = (data) => {
        setVisible(true);
        setHsnId(data.id);
        //let a = productGstdetails && productGstdetails.filter(function (el) { return el.id === data.productGstId });
        setForm({
            hsnCode: data.hsnCode,
            description: data.description,
            chapter: data.chapter,
            productGst: data.productGst
        });
    }

    const dispatch = useDispatch();

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        let filter = { ["or"]: [] };
        if (search !== '') {
            filter['or'].push({ hsnCode: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ description: { like: '%' + search.trim() + '%' } });
        }
        dispatch({
            type: actions.HSN_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'hsns',
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    return (
        <React.Fragment>
            <MainHeader  {...props}
                img={SettingsImg}
                title={moduleType !== undefined ? moduleType : 'Younote Admin'} links={[{ 'label': moduleType !== undefined ? moduleType : 'Younote Admin', 'link': moduleType === 'Admin' ? '/admin' : '/younote-admin' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'HSN Code'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('HSN Code', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                value={search}
                                                className={classes.comInput}
                                                required
                                                variant={'standard'}
                                                onChange={(e) => setSearch(e.target.value)}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkComponentPermission('HSN Code', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => { loadImportExportData('HSNCode'); }}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('HSN Code', 'Action', 'Import') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => { setImportVisible(true); }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && (checkCRUDPermission('HSN Code', 'create', 'Younote Admin') || checkCRUDPermission('HSN Code', 'create', 'Admin')) &&
                                                <NavLink
                                                    to={"#"}
                                                    onClick={() => handleOpen()}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add HSN Code</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('HSN Code', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <HsnCodeTable
                                loadTasks={() => dispatchFilter(sortBy, sortOrder)}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                moduleType={moduleType}
                                onEdit={(data) => onEdit(data)}
                                onDelete={(data) => onDelete(data)}
                                details={getList}
                                length={getData && getData?.length ? getData?.length : 0}
                                productGstdetails={productGstdetails}
                                sortOrder={sortOrder}
                                roleManagement={roleManagement}
                                sortBy={sortBy} onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
                <PrimaryDrawer
                    anchor={'right'}
                    open={visible}
                    variant={'temporary'}
                    handleClose={() => handleClose()}
                    title={`${hsnId ? 'Edit' : 'Add'}  HSN Code`}
                    className={clsx(classes.closeBackGround, classes.width100P)}
                    component={
                        <Box
                            className={clsx(classes.customForm, classes.removeUnderline)}
                            component="form"
                            autoComplete="off"
                            onSubmit={(e) => createHsnCode(e)}>
                            <div className={classes.customFormFlex}>
                                {
                                    commonError && <CustomAlert error={commonError} customClass={clsx(classes.uploadError, classes.margin10t)} />
                                }
                                <TextField autoComplete='one-time-code'
                                    label={["HSN Code ", <span key={"HSN Code"} className={classes.colorRedRequired}> *</span>]}
                                    variant={'standard'}
                                    error={errorCode ? true : false}
                                    helperText={errorCode}
                                    name={"hsnCode"}
                                    value={form.hsnCode}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => changeHandler(e)}
                                />
                                <TextField autoComplete='one-time-code'
                                    label={["Description ", <span key={"Description"} className={classes.colorRedRequired}> *</span>]}
                                    name={"description"}
                                    value={form.description}
                                    multiline
                                    variant="outlined"
                                    className={clsx(classes.margin20t, classes.customDescription)}
                                    rows={4}
                                    error={errorDescription ? true : false}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColor,
                                    }}
                                    onChange={(e) => changeHandler(e)}
                                />
                                <TextField autoComplete='one-time-code'
                                    label='Chapter'
                                    variant={'standard'}
                                    name={"chapter"}
                                    value={form.chapter ? form.chapter : ''}
                                    className={clsx(classes.margin20t)}
                                    error={errorChapter ? true : false}
                                    helperText={errorChapter}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}

                                    onChange={(e) => changeHandler(e)}
                                />
                                <TextField autoComplete='one-time-code'
                                    type={'number'}
                                    label='Product Gst'
                                    variant={'standard'}
                                    name={"productGst"}
                                    onWheel={(e) => e.target.blur()}
                                    value={form?.productGst}
                                    className={clsx(classes.margin20t)}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => changeHandler(e)}
                                />
                            </div>

                            <div className={clsx(classes.btnParent)}>
                                <Space size={[10, 10]} direction="horizontal" align="center">
                                    <Button
                                        key="save"
                                        type='submit'
                                        color='primary'
                                        variant="contained"
                                        className={clsx(classes.modalBtn, { [classes.loading]: createLoader || editLoader })}
                                    >
                                        {
                                            hsnId ? 'Update & Close' : 'Save & Close'
                                        }
                                    </Button>
                                    {
                                        !hsnId &&
                                        <Button
                                            key="add"
                                            onClick={(e) => handleAddMore(e)}
                                            color='primary'
                                            variant="contained"
                                            className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader })}
                                        >
                                            Add more
                                        </Button>
                                    }
                                </Space>
                            </div>
                        </Box>
                    }
                />
                <DeleteModal onClose={(v) => handleDeleteModal(v)} id={hsnId} loadTasks={() => dispatchFilter(sortBy, sortOrder)} name={hsnCode} url={'hsns'} title={'HSN Code'} visible={deleteModal} />
            </div>
            <ImportExport
                handleClose={() => { setImportVisible(false); }}
                visible={importVisible}
                title={'HSNCode'}
                type={'import'}
                loader={hsnLoader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={hsnDetails}
                loadTasks={() => { dispatchFilter(sortBy, sortOrder) }}
            />
        </React.Fragment>
    )

}


export default HsnCode